import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

const RESPONSE_TIME = {
    MARGINAL: 3.0,
    CRITICAL: 8.0,
};

export const WEB_DEFAULT_THRESHOLD = {
    degraded: RESPONSE_TIME.MARGINAL,
    critical: RESPONSE_TIME.CRITICAL,
};

export const GEOIP_URL = '/ipm/v1/open/agents/:_id/location';

export const HTTP_RESPONSE_CODES = {
    '*': 'Any Response',
    200: t`200 - Ok`,
    201: t`201 - Created`,
    202: t`202 - Accepted`,
    204: t`204 - No Content`,
    301: t`301 - Redirect`,
    302: t`302 - Found`,
    303: t`303 - See Other`,
    304: t`304 - Not Modified`,
    400: t`400 - Bad Request`,
    401: t`401 - Unauthorized`,
    403: t`403 - Forbidden`,
    404: t`404 - Not Found`,
    500: t`500 - Internal Server Error`,
    503: t`503 - Service Unavailable`,
};

export const MAX_AGENTS = 30;

export const GET_METHOD = 'GET';
export const POST_METHOD = 'POST';
export const AUTH_NONE = 'none';
export const AUTH_BASIC = 'basic';
export const AUTH_NTLM = 'ntlm';
export const AUTH_USER_CERT = 'cert';
export const METHOD_NAMES = {
    [GET_METHOD]: i18n._(t`GET`),
    [POST_METHOD]: i18n._(t`POST`),
};
export const AUTH_NAMES = {
    [AUTH_NONE]: i18n._(t`None`),
    [AUTH_BASIC]: i18n._(t`Basic`),
    [AUTH_NTLM]: i18n._(t`NTLM`),
    [AUTH_USER_CERT]: i18n._(t`User Certificate`),
};

export const EMPTY_POST = { name: '', value: '' };
